import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import { API_BASE } from "../config";
import { Helmet } from "react-helmet";



export default function ViewSchools() {

  

  const location = useLocation();
  const navigate = useNavigate();
  // const queryParams = new URLSearchParams(location.search);

  // // ------------------ APPLIED FILTERS FROM URL ------------------
  // const appliedDistrict = queryParams.get("district") || "0";
  // const appliedActivity = queryParams.get("activity") || "0";
  // const appliedFY = queryParams.get("fy") || "";
  // const appliedStatus = queryParams.get("status") || "submitted";

  const saved = JSON.parse(sessionStorage.getItem("viewSchoolsFilters") || "{}");
  const appliedDistrict = saved.district || "0";
  const appliedActivity = saved.activity || "0";
  const appliedFY = saved.fy || "";
  const appliedStatus = saved.status || "submitted";


  // ------------------ FY FUNCTION ------------------
  const getCurrentFY = () => {
    const today = new Date();
    const yr = today.getFullYear();
    const mo = today.getMonth() + 1;
    return mo < 4 ? `${yr - 1}-${yr}` : `${yr}-${yr + 1}`;
  };
  const currentFY = getCurrentFY();

  const getFYList = () => {
    const [start, end] = currentFY.split("-").map(Number);
    return [`${start - 1}-${end - 1}`, `${start}-${end}`, `${start + 1}-${end + 1}`];
  };
  const financialYears = getFYList();

  // ------------------ SELECTED FILTERS (UI ONLY) ------------------
  const [selectedDistrict, setSelectedDistrict] = useState(appliedDistrict);
  const [selectedActivity, setSelectedActivity] = useState(appliedActivity);
  const [selectedFY, setSelectedFY] = useState(appliedFY || currentFY);
  const [selectedStatus, setSelectedStatus] = useState(appliedStatus);

  const [districts, setDistricts] = useState([]);
  const [activities, setActivities] = useState([]);
  const [schoolData, setSchoolData] = useState([]);

  // LOAD MASTER DATA
  useEffect(() => {
    axios.get(`${API_BASE}/districts`).then((res) => setDistricts(res.data));
    axios.get(`${API_BASE}/activities`).then((res) => setActivities(res.data));
  }, []);

  // ------------------ FETCH SCHOOL DATA (INCLUDES NOT SUBMITTED FIX) ------------------
  useEffect(() => {
    axios
      .get(`${API_BASE}/schools-by-filter`, {
        params: {
          district: appliedDistrict,
          fy: appliedFY,
          activity: appliedActivity,
        },
      })
      .then((res) => {
        setSchoolData(res.data);
      })
      .catch((err) => console.error(err));
  }, [appliedDistrict, appliedActivity, appliedFY]);

  // ------------------ NEW STATUS FILTER LOGIC ------------------
  const filteredData =
    appliedStatus === "submitted"
      ? schoolData.filter((row) => Number(row.total_activities) > 0)
      : schoolData.filter((row) => Number(row.total_activities) === 0);

  // ------------------ SEARCH BUTTON ACTION ------------------
  const handleSearch = () => {
    // navigate(
    //   `/view-schools?district=${selectedDistrict}&activity=${selectedActivity}&fy=${selectedFY}&status=${selectedStatus}`
    // );
    sessionStorage.setItem("viewSchoolsFilters", JSON.stringify({
      district: selectedDistrict,
      activity: selectedActivity,
      fy: selectedFY,
      status: selectedStatus,
    }));
    
    navigate("/view-schools");
    
  };

  // ------------------ DYNAMIC HEADING BASED ON APPLIED FILTERS ------------------
  const appliedDistrictName =
  selectedDistrict === "0"
    ? "All"
    : districts.find((d) => String(d.dist_id) === String(selectedDistrict))?.district || "All";


  const appliedActivityName =
    appliedActivity === "0"
      ? "All"
      : activities.find((a) => String(a.activities_id) === appliedActivity)?.activity || "All";

  // const headingText = `Activity Submission Status (District: ${appliedDistrictName} | Activity: ${appliedActivityName} | FY: ${appliedFY} | Status: ${
  //   appliedStatus === "submitted" ? "Submitted" : "Not Submitted"
  // })`;
  const headingText = (
    <span>
      Activity Submission Status (
        District: <span style={{ color: "green", fontWeight: "600" }}>{appliedDistrictName}
      </span>{" "}
      |{" "}
        Activity:  <span style={{ color: "green", fontWeight: "600" }}>{appliedActivityName}
      </span>{" "}
      |{" "}
        FY:  <span style={{ color: "green", fontWeight: "600" }}>{appliedFY}
      </span>{" "}
      |{" "}
        Status: <span
        style={{
          color: appliedStatus === "submitted" ? "green" : "red",
          fontWeight: "700",
        }}
      >{appliedStatus === "submitted" ? "Submitted" : "Not Submitted"}
      </span>
      )
    </span>
  );
  


  const exportToExcel = (data) => {
    const sheetData = data.map((row, index) => ({
      "Sl. No": index + 1,
      "School Name": row.school_name,
      "Activities Submitted": row.total_activities,
      "Contact No": row.contact_no,
      "Contact Name": row.contact_name,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Schools");
  
    XLSX.writeFile(workbook, "School_Report.xlsx");
  };
  

  return (
      <>
        <Helmet>
          <title>Activity Status</title>
        </Helmet>
         
    <div style={{ padding: 30, background: "#f7f8fa", minHeight: "100vh" }}>
      {/* --------------------------- FILTER BOX --------------------------- */}
<div
  style={{
    background: "#ffffff",
    padding: "20px 15px",
    borderRadius: 12,
    marginBottom: 25,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }}
>
  <div style={{display:"flex",justifyContent:"space-between"}}>
  <div>
  <h2
    style={{
      margin: 0,
      marginBottom: 20,
      color: "#1a237e",
      fontSize: 22,
      fontWeight: 600,
    }}
  >
    Activity Submission Status
  </h2>
  </div>
{/* --------------------------- TOP RIGHT BUTTONS --------------------------- */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "15px",
  }}
>
  {/* Back Button */}
  <button
  // onClick={() => {
  //   if (window.history.length > 1) {
  //     navigate(-1);
  //   } else {
  //     window.close();
  //   }
  // }}
  onClick={() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      if (appliedStatus === "submitted") {
        navigate("/");
      } else {
        navigate("/ActivityNotSubmitted");
      }
    }
  }}
  
  style={{
    padding: "10px 18px",
    background: "#9e2c2c",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
  }}
>
  Back
</button>


  {/* Export to Excel */}
  <button
    onClick={() => exportToExcel(filteredData)}
    style={{
      padding: "10px 18px",
      background: "#2e7d32",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: "pointer",
      fontWeight: 600,
    }}
  >
    Export to Excel
  </button>
</div>
</div>
  <div
    style={{
      display: "flex",
      gap: 14,
      alignItems: "center",
      flexWrap: "wrap",
    }}
  >
    {/* FORM FIELD STYLE */}
    <style>
      {`
        .filter-label {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: flex;
          flex-direction: column;
        }

        .filter-select {
          padding: 10px 12px;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 14px;
          margin-top: 5px;
          background: #fafafa;
          cursor: pointer;
          min-width: 180px;
        }

        .filter-select:focus {
          outline: none;
          border-color: #1a73e8;
          box-shadow: 0 0 0 3px rgba(26,115,232,0.2);
        }

        .search-btn {
          padding: 12px 26px;
          background: #1976d2;
          color: #fff;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: 15px;
          font-weight: 600;
          transition: 0.2s ease-in-out;
          margin-top: 18px;
        }

        .search-btn:hover {
          background: #0f5bb5;
        }
      `}
    </style>

    {/* DISTRICT */}
    <label className="filter-label">
      District
      <select
        className="filter-select"
        value={selectedDistrict}
        onChange={(e) => setSelectedDistrict(e.target.value)}
      >
        <option value="0">All</option>
        {districts.map((d) => (
          <option key={d.dist_id} value={d.dist_id}>
            {d.district}
          </option>
        ))}
      </select>
    </label>

    {/* ACTIVITY */}
    <label className="filter-label">
      Activity
      <select
        className="filter-select"
        value={selectedActivity}
        onChange={(e) => setSelectedActivity(e.target.value)}
      >
        <option value="0">All</option>
        {activities.map((a) => (
          <option key={a.activities_id} value={a.activities_id}>
            {a.activity}
          </option>
        ))}
      </select>
    </label>

    {/* FINANCIAL YEAR */}
    <label className="filter-label">
      Financial Year
      <select
        className="filter-select"
        value={selectedFY}
        onChange={(e) => setSelectedFY(e.target.value)}
      >
        {financialYears.map((fy) => (
          <option key={fy} value={fy}>
            {fy}
          </option>
        ))}
      </select>
    </label>

    {/* SUBMISSION STATUS */}
    <label className="filter-label">
      Submission Status
      <select
        className="filter-select"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="submitted">Submitted</option>
        <option value="not_submitted">Not Submitted</option>
      </select>
    </label>

    {/* SEARCH BUTTON */}
    <button className="search-btn" onClick={handleSearch}>
      Search
    </button>
  </div>
</div>




      {/* --------------------------- HEADING BELOW FILTER --------------------------- */}
      <h2 style={{ marginBottom: 20, color: "rgb(40 53 147)",fontSize:"1em" }}>{headingText}</h2>

      {/* --------------------------- TABLE --------------------------- */}
      <div
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
       <style>{`
  .tblview th {
    text-align: left;
    padding: 12px;
    background: #283593;
    color: white;
  }
`}</style>

        <table className="tblview" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#283593", color: "white" }}>
              <th>Sl. No</th>
              <th>School Name</th>
              <th>Activities Submitted</th>
              <th>Contact No.</th>
              <th>Contact Name</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ padding: 20, textAlign: "center" }}>
                  No Records Found
                </td>
              </tr>
            ) : (
              filteredData.map((row, idx) => (
                <tr key={row.enrclub_id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: 12 }}>{idx + 1}</td>
                  <td style={{ padding: 12 }}>{row.school_name}</td>
                  <td style={{ padding: 12 }}>{row.total_activities}</td>
                  <td style={{ padding: 12 }}>{row.contact_no}</td>
                  <td style={{ padding: 12 }}>{row.contact_name}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
}
